import { ENV_BASE_URL } from 'env';
import { getCurrentUrl } from 'common/utils/getUrl';

interface IGetScormUrlOptions {
    preview?: boolean;
}

export function getScormUrl(
    scormId: string,
    { preview }: IGetScormUrlOptions = {}
) {
    const nextUrl = getCurrentUrl();
    const previewParam = preview ? '&preview=true' : '';

    return `${ENV_BASE_URL}/scorm/${scormId}/?next=${nextUrl}${previewParam}`;
}
